export const setUuidFromQuery = (
  query: string | string[] | undefined
): string | undefined => {
  if (!query) {
    return undefined;
  }

  if (typeof query !== "string") {
    return undefined;
  }

  return query;
};
